module.exports = __webpack_public_path__ + "static/img/faq.6ea3b7cb.png";